/**
 * `Listing` is abstract class used to create any listings (product, category, error, static, .. )
 * Listing can be pretty much anything
 *
 * # Listing type
 *
 * Each listing needs `type` string property set. This is to distinguish what kind of listing it is.
 * Example: product, category, ..
 *
 * This variable is used in many places of code and is absolutely required.
 *
 * Note that type determines from what mongo table data is loaded.
 *
 * # Routable listings
 *
 * If listing is routable it requires private property _routable = true.
 * Everytime instance of this listing is loaded its path is registered in resource
 *
 *
 * # Listing id
 *
 * Id can be either string or number. It's main way to load and identify listings.
 *
 *
 * # Singleton listing
 *
 * When listing has as only one instance (like customer) then it does not require id.
 * Such listing is singleton and we can create it by registration in resource with singleton : true option.
 * Any other listing will require id to be identified.
 *
 *
 * ## Creating listing class
 *
 * This is product class example.
 * `Product` class is created simply by extension of `Listing`.
 * We declare required `type` and for this kind of listing we add _routable flag also.
 * After declaration we register our listing in resource (other way it can be used, but not with resource)
 * Note that Resource is static class.
 *
 *
 * export class Product<T> extends Listing<T> {
 *      type = 'product';
 *      protected _routable = true;
 * }
 *
 * Resource.register({
 *      typeName: 'product',
 *      instanceClass :  Product
 * });
 *
 */
/**
 * Loads subscription data on page init
 */
import { Listing } from '@df/catalog-ui/listing/listing';
import { IModelData, Model } from '@df/catalog/model';



export class LocalListing<T extends Model<IModelData, string | number> = Model> extends Listing<T> {
    overrideFilteredModels(models: T[]){
        this.setModelsFiltered(models);
        if (!!this.modelsFiltered || !this.limit) {
            this.updateLimits();
        }
        this.sortModels();
    }

    getModelsBare():T[] {
        return this.modelsBare;
    }

}
